module.exports = __webpack_public_path__ + "img/male-adult-figure.69040c71.svg";